import { render, staticRenderFns } from "./ShippingAddressManage.vue?vue&type=template&id=e6da9508&scoped=true&"
import script from "./ShippingAddressManage.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6da9508",
  null
  
)

export default component.exports